<template>
    <!-- New SMS Content Modal -->
    <b-modal
      id="sms-content-modal"
      title="Metin Ekle"
      size="lg"
      centered
      :visible="showSmsContentModal"
      @change="(val) => $emit('update:show-sms-content-modal', val)"
    >
      <template #default>
        <b-form @submit.prevent="saveSmsContent">
          
          <b-form-group label="Kısa Link">
            <b-form-input 
              v-model="shortLink" 
              readonly 
              :value="shortLink"
            />
          </b-form-group>
  
  
          <b-card 
            v-if="previewContent" 
            title="Önizleme" 
            class="mt-2 border-danger position-relative"
          >
            <feather-icon 
              icon="CopyIcon"
              v-b-tooltip.hover.v-primary
              title="Panoya Kopyala"
              @click="copyPreviewContent"
              class="cursor-pointer position-absolute" 
              style="right: 10px; bottom: 10px;"
              size="28"
            />
            <p v-html="previewContent"></p>
            <small class="text-muted" v-if="link.type == 2">
              {{ characterCount }} Karakter / {{ smsPartCount }} Kontör
            </small>
          </b-card>

          <b-form-group label="Paylaşım içeriği" v-else>
            <b-form-textarea
              v-model="smsContent"
              placeholder="Paylaşım içeriğini buraya yazın"
              rows="4"
              @input="updateCharacterCount"
            />
            <div class="d-flex justify-content-between mt-1 text-muted" v-if="link.type == 2">
              <small class="text-danger">
                {{ characterCount }} Karakter / {{ smsPartCount }} Kontür
              </small>
              <small>
                Maks 912 Karakter ({{ 160 * 6 }} karakter)
              </small>
            </div>
          </b-form-group>
  
          <div class="d-flex justify-content-between mt-2" v-if="!previewContent" >
            <b-form-checkbox v-model="wantsSmsContent">
              Metin Eklemek İstiyorum
            </b-form-checkbox>
          </div>
        </b-form>
      </template>
      
      <template #modal-footer="{ hide }">
        
        <div class="d-flex mt-2 justify-content-between w-100">
        <b-button 
          variant="outline-secondary" 
          @click="hide"
        >
          Eklemeden devam et
        </b-button>
        <div>
            <b-button 
                variant="primary" 
                @click="generatePreview"
                :disabled="!wantsSmsContent"
                v-if="!previewContent"
            >
                Önizleme Oluştur
            </b-button>
            <div v-else>
                <b-button class="mr-1"
                variant="secondary" 
                @click="previewContent=''"
                >
                Düzenle
                </b-button>

                <b-button 
                variant="primary" 
                @click="saveSmsContent"
                >
                Onayla ve Kaydet
                </b-button>
            </div>
        </div>
        </div>
      </template>
    </b-modal>
  </template>
  
  <script>
  import {
    BModal,BFormDatepicker, BFormCheckbox, BFormTimepicker, BRow, BCol, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BFormInvalidFeedback, BButton, BCard,
    BCardBody,BSpinner,
    BFormTextarea,
    BFormFile,
    VBTooltip
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { ref, onMounted, watch,computed  } from '@vue/composition-api'
  import { required, url, hasDomain } from '@validations'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import { useToast } from 'vue-toastification/composition'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'
  import axiosIns from '@/axios'
  import store from '@/store'
  
  export default {
    components: {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BFormFile,
        BFormTextarea,
        BFormInvalidFeedback,
        BButton,
        BSpinner,
        BInputGroup,
        vSelect,
        BFormCheckbox,
        BFormDatepicker,
        BFormTimepicker,
        ValidationProvider,
        BInputGroupAppend,
        ValidationObserver,
        BFormInput,
        BCard,
        BCardBody,
        BRow,
        BCol,
    },
    directives: {
        Ripple,
    },
    model: {
        prop : 'showSmsContentModal',
        event: 'update:show-sms-content-modal',
    },
    directives: {
        'b-tooltip': VBTooltip
    },
    props: {
        showSmsContentModal: {
            type: Boolean,
            required: true,
        },
        link: { // Düzenlenecek link verisi
            type: Object,
            default: null,
        },
    },

    setup(props, { emit }) {
        const toast = useToast()

        const shortLink = ref('');
        const smsContent = ref('');
        const wantsSmsContent = ref(false);
        
        // New preview-related reactive variables
        const previewContent = ref('');
        const characterCount = ref(0);
        const smsPartCount = ref(1);
  
        const updateCharacterCount = () => {
          // Calculate character count
        //   const totalContent = smsContent.value.replace('{#link#}', shortLink.value);
        const totalContent = smsContent.value.replace('{#link#}', `<a href="${shortLink.value}">${shortLink.value}</a>`);
          characterCount.value = totalContent.length;
          
          // Calculate SMS parts (kontürs)
          smsPartCount.value = Math.ceil(characterCount.value / 160);
        };
  
        const generatePreview = () => {
          // Replace {#link#} with actual short link
          if (!smsContent.value.includes('{#link#}')) {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'AlertTriangleIcon',
                variant: 'warning',
                title: 'Lütfen {#link#} ile link konumunu belirtin',
              },
            });
            return;
          }
  
          // Generate preview by replacing {#link#} with actual short link
          previewContent.value = smsContent.value.replace('{#link#}', `<a href="${shortLink.value}">${shortLink.value}</a>`);
          
          // Update character count for preview
          updateCharacterCount();
        };
  
        const copyPreviewContent = () => {
          
          // Remove HTML tags for plain text copying
        //   const plainTextContent = previewContent.value.replace(/<[^>]*>/g, '');
          
          navigator.clipboard.writeText(previewContent.value)
          .then(() => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'CopyIcon',
                variant: 'success',
                title: 'Link kopyalandı!',
              },
            });
          })
          .catch((err) => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'InfoIcon',
                variant: 'warning',
                title: `Link kopyalanırken hata oluştu: ${err.message}`,
              },
            });
          });
        };
  
        const saveSmsContent = () => {

            
          // Check if preview is approved and SMS content is wanted
          if (!wantsSmsContent.value) {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'AlertTriangleIcon',
                variant: 'warning',
                title: 'Lütfen önce önizlemeyi onaylayın',
              },
            });
            return;
          }
  
          // Check SMS content length
          if (characterCount.value > 912) {  // 6 parts * 160 characters
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'AlertTriangleIcon',
                variant: 'warning',
                title: 'SMS içeriği çok uzun. Maks 912 karakter olmalı.',
              },
            });
            return;
          }
  
          let postData = {
                // Explicitly pick only the properties you want to send
                ...props.link, // Assuming link has an id
                description: smsContent.value,
                inf_ids: Array.isArray(props.link.inf_id) 
                    ? props.link.inf_id 
                    : props.link.inf_id 
                        ? [props.link.inf_id] 
                        : []
            };

            axiosIns.put(`/link`, postData)
                .then((response) => {
                    if (response.data.success) {
                        emit('update:show-sms-content-modal', false);
                        toast({
                            component: ToastificationContent,
                            position: 'bottom-right',
                            props: {
                                icon: 'CheckCircleIcon',
                                variant: 'success',
                                title: 'Metin Başarıyla Kaydedildi',
                            },
                        });
                    }
                })
                .catch((error) => {
                    toast({
                        component: ToastificationContent,
                        position: 'bottom-right',
                        props: {
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            title: 'Metin Kaydedilemedi',
                        },
                    });
                });
        };
  
        // Watchers
        watch(() => smsContent.value, () => {
          // Reset preview and approval when content changes
          previewContent.value = '';
          updateCharacterCount();
        });

        watch(() => props.link, (newData) => {
          // Reset preview and approval when content changes
          shortLink.value = newData.short_url
          smsContent.value = `Mesaj içeriğini giriniz. {#link#}`
          if(newData.description){
            smsContent.value=newData.description
            wantsSmsContent.value=true
          }
          updateCharacterCount();
        });
  
        return {
          shortLink,
          smsContent,
          wantsSmsContent,
          previewContent,
          characterCount,
          smsPartCount,
          generatePreview,
          saveSmsContent,
          updateCharacterCount,
          copyPreviewContent
        };
    }
  }
  </script>